import React from 'react';
import { I18n as I } from 'react-redux-i18n';
import { Link } from 'react-router';

import OperatorExpertDetails from './OperatorExpertDetails';
import InsuranceMerchantDetails from './InsuranceMerchantDetails';

import { ConfirmationModal, bind, equal, isNil, PartyTypes } from 'vdlib';
import LookupsHelper from 'lib/LookupsHelper';

import { Button, Tooltip } from 'antd';

import {
  LoginOutlined,
  LogoutOutlined,
  RedoOutlined,
  CloseOutlined,
  EditOutlined,
} from '@ant-design/icons';

import Portlet from '../layout/Portlet';

import { history } from 'data/Store';

class Party extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      partyIdToDelete: null,
      partyIdToResetPassword: null,
      partyIdEnableDisable: null,
    };
    bind(this, ['init', 'populate', 'isValidId']);
  }

  componentDidMount() {
    const { params } = this.props;

    this.init(params.id);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id != nextProps.params.id) return this.init();

    if (this.props.submitting === true && nextProps.submitting !== true)
      return history.push({ pathname: '/all-parties' });

    if (
      nextProps.party != null &&
      (isNil(this.portletTitle) || !equal(this.props.party, nextProps.party))
    ) {
      this.populate(nextProps);
    }
  }

  isValidId(id) {
    if (isNil(id)) id = this.props.params.id;

    try {
      return parseInt(id) + '' == id + '';
    } catch (e) {
      return false;
    }
  }

  init(partyId) {
    if (this.isValidId(partyId)) {
      this.props.fetchParty(partyId);
    }
  }

  populate(props) {
    if (isNil(props)) props = this.props;

    if (!isNil(props.party)) {
      let status = props.party.IsInactive ? I.t('INACTIVE_C') : I.t('ACTIVE_C');
      this.portletTitle =
        LookupsHelper.getDescription(
          props.partyTypes,
          props.party.PartyTypeID
        ) +
        ' - ' +
        status;
      // create portlet actions for each role
      this.portletActions = [
        <div
          className="btn-group btn-group-devided"
          data-toggle="buttons"
          key="action-group-1"
        >
          <Tooltip title={I.t('EDIT')}>
            <Link to={`/parties/${props.params.id}/edit`}>
              <Button
                type="primary"
                shape="circle"
                style={{
                  borderColor: 'blue',
                  backgroundColor: 'white',
                  marginRight: 5,
                  borderRadius: '50% !important',
                  color: 'blue',
                }}
                icon={<EditOutlined />}
              />
            </Link>
          </Tooltip>
          <Tooltip
            title={
              props.party.IsInactive ? I.t('ACTIVATION') : I.t('DEACTIVATION')
            }
          >
            <Button
              type="primary"
              shape="circle"
              style={{
                borderColor: props.party.IsInactive ? '#009307' : '#d6b200',
                backgroundColor: 'white',
                marginRight: 5,
                borderRadius: '50% !important',
                color: props.party.IsInactive ? '#009307' : '#d6b200',
              }}
              icon={
                props.party.IsInactive ? <LoginOutlined /> : <LogoutOutlined />
              }
              onClick={e =>
                this.setState({ partyIdEnableDisable: this.props.party.ID })
              }
            />
          </Tooltip>
          <Tooltip title={I.t('RESET_PASSWOD')}>
            <Button
              type="primary"
              shape="circle"
              style={{
                borderColor: 'gray',
                backgroundColor: 'white',
                marginRight: 5,
                borderRadius: '50% !important',
                color: 'gray',
              }}
              icon={<RedoOutlined />}
              onClick={e =>
                this.setState({ partyIdToResetPassword: this.props.party.ID })
              }
            />
          </Tooltip>
          <Tooltip title={I.t('DELETE')}>
            <Button
              type="primary"
              shape="circle"
              style={{
                borderColor: 'red',
                backgroundColor: 'white',
                marginRight: 5,
                borderRadius: '50% !important',
                color: 'red',
              }}
              icon={<CloseOutlined />}
              onClick={e =>
                this.setState({ partyIdToDelete: this.props.party.ID })
              }
            />
          </Tooltip>
        </div>,
      ];
    }
  }

  render() {
    if (!this.isValidId()) return false;

    let isOperatorExpert =
      (this.props.party || {}).PartyTypeID == 1 ||
      (this.props.party || {}).PartyTypeID == 3
        ? true
        : false;
    let IsInactive = (this.props.party || {}).IsInactive;
    return (
      <div className="party-wrap">
        {isNil(this.props.party)
          ? null
          : [
              <Portlet
                key="main"
                icon="icon-settings"
                title={this.portletTitle}
                showBackButton={true}
                actions={this.portletActions}
              >
                {isOperatorExpert ? (
                  <OperatorExpertDetails
                    countries={this.props.countries}
                    party={this.props.party}
                    regions={this.props.regions}
                    taxOffices={this.props.taxOffices}
                    user={this.props.user}
                  />
                ) : (
                  <InsuranceMerchantDetails
                    applications={this.props.applications}
                    countries={this.props.countries}
                    party={this.props.party}
                    partyAppMemberships={this.props.partyAppMemberships}
                    regions={this.props.regions}
                    taxOffices={this.props.taxOffices}
                    user={this.props.user}
                    isMerchant={
                      LookupsHelper.getDescription(
                        this.props.partyTypes,
                        this.props.party.PartyTypeID
                      ) === PartyTypes.Merchant
                    }
                  />
                )}
                <div className="row" />
              </Portlet>,
            ]}
        <ConfirmationModal
          onHide={() => this.setState({ partyIdToDelete: null })}
          show={this.state.partyIdToDelete != null}
          title={I.t('PARTY_DELETE')}
          onSubmit={() => this.props.deleteParty(this.state.partyIdToDelete)}
          loading={this.props.submitting}
          promptText={
            <div className="note note-danger">
              {I.t('MODAL_QUESTION_PARTY_DELETE')}
              <span className="bold">
                {(this.props.party || {}).FirstName}{' '}
                {(this.props.party || {}).SurName}
              </span>
              <br />
              <br />
              {I.t('ARE_YOU_SURE')}
            </div>
          }
        />
        <ConfirmationModal
          onHide={() => this.setState({ partyIdToResetPassword: null })}
          show={this.state.partyIdToResetPassword != null}
          title={I.t('RESET_PASSWORD')}
          onSubmit={() =>
            this.props.resetPassword(this.state.partyIdToResetPassword)
          }
          loading={this.props.submitting}
          promptText={
            <div className="note note-danger">
              {I.t('MODAL_QUESTION_PASSWORD_RESET')}
              <span className="bold">
                {(this.props.party || {}).FirstName}{' '}
                {(this.props.party || {}).SurName}
              </span>
              <br />
              <br />
              {I.t('ARE_YOU_SURE')}
            </div>
          }
        />
        <ConfirmationModal
          onHide={() => this.setState({ partyIdEnableDisable: null })}
          show={this.state.partyIdEnableDisable != null}
          title={I.t('ACTIVATE_DEACTIVATE')}
          onSubmit={() =>
            this.props.enableDisableParty(this.state.partyIdEnableDisable)
          }
          loading={this.props.submitting}
          promptText={
            <div className="note note-warning">
              {IsInactive
                ? I.t('MODAL_QUESTION_PARTY_ACTIVATE')
                : I.t('MODAL_QUESTION_PARTY_DEACTIVATE')}
              <span className="bold">
                {(this.props.party || {}).FirstName}{' '}
                {(this.props.party || {}).SurName}
              </span>
              <br />
              <br />
              {I.t('ARE_YOU_SURE')}
            </div>
          }
        />
      </div>
    );
  }
}

export default Party;
